import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	.modalon {
		position: absolute;
		z-index: 1000;

		left: calc(50% - 15%);
		top: 200px;

		background-color: rgb(190, 190, 190);
		border-radius: 10px;
		padding: 10px;

		.button-area {
			display: flex;
			gap: 30px;
			margin-top: 20px;
			justify-content: center;

			button {
				padding: 10px 60px;
				border: 10px;
				color: black;
				font-weight: 700;
			}
			:hover {
				scale: 1.05;
			}
		}
	}
	.modalOff {
		display: none;
		transition: 600ms;
	}

	.action-area {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 5px 35px;
		margin-bottom: 10px;
		background-color: rgb(236, 251, 255);
		border-radius: 8px;

		strong {
			font-weight: 900;
		}

		.buttons {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 20px;
			button {
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 8px;
				transition: 300ms ease;
			}
			svg {
				font-size: 40px;
				padding: 10px;
			}
			button:hover#delete {
				background-color: rgb(167, 73, 104);
				color: white;
			}
			button:hover#edit {
				background-color: rgb(73, 167, 147);
				color: white;
			}
		}
		.off {
			button {
				color: rgb(168, 168, 168);
			}
			button:hover#edit,
			button:hover#delete {
				color: rgb(168, 168, 168);
			}
		}
	}
`;
export const NoticeListWrapper = styled.ul`
	display: flex;
	flex-direction: column;
	overflow-y: scroll;
	min-height: calc(100vh - 20px - 10px - 50px);
	height: max-content;

	gap: 10px;

	li {
		display: flex;
		gap: 10px;
		align-items: center;
		border: 2px solid #2e2e2e;
		border-radius: 8px;
		padding: 10px 10px;
		width: 98%;

		input {
			width: 20px;
			height: 20px;
		}
		h3 {
			color: black;
		}
		span {
			color: gray;
			font-size: 12px;
		}
	}
`;
